
import { Facebook, Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-primary text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">DubCity AI Solutions</h3>
            <p className="text-white/70">
              Transforming workflows with custom AI solutions.
            </p>
            <div className="mt-4 space-y-2">
              <a 
                href="tel:0221299230" 
                className="flex items-center gap-2 text-white/70 hover:text-accent transition-colors"
              >
                <Phone className="h-4 w-4" />
                <span>02 2129 9230</span>
              </a>
              <a 
                href="mailto:dubcityaisolutions@gmail.com" 
                className="flex items-center gap-2 text-white/70 hover:text-accent transition-colors"
              >
                <Mail className="h-4 w-4" />
                <span>dubcityaisolutions@gmail.com</span>
              </a>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-white/70 hover:text-accent">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-white/70 hover:text-accent">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Follow Us</h4>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/profile.php?id=61573145607244" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-white/70 hover:text-accent"
              >
                <Facebook className="h-6 w-6" />
              </a>
              <a 
                href="https://www.tiktok.com/@dubcity.ai.soluti?is_from_webapp=1&sender_device=pc" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-white/70 hover:text-accent"
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="24" 
                  height="24" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  className="h-6 w-6"
                >
                  <path d="M9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/>
                  <path d="M7 16h4"/>
                  <path d="M15 12h-2"/>
                  <path d="M9 12h.01"/>
                  <rect x="4" y="4" width="16" height="16" rx="4"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-white/10 text-center text-white/70">
          <p>&copy; 2024 DubCity AI Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
